import { render, staticRenderFns } from "./PremiumConceptDesc.vue?vue&type=template&id=96e6ce86&scoped=true"
import script from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
export * from "./PremiumConceptDesc.vue?vue&type=script&lang=js"
import style0 from "./PremiumConceptDesc.vue?vue&type=style&index=0&id=96e6ce86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e6ce86",
  null
  
)

export default component.exports